import { Routes } from '@angular/router';

export const addCollectionRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./add-collection.page').then((m) => m.AddCollectionPage),
  },
];
